export const ERROR_FROM_SERVER = 'server-error';
